/**
 *
 * @param sortColumns [{index:1, direction:'asc'}, {index:3, direction:'desc'}] - sorts by column 1 ascending then 3 descending
 * @returns {function(*, *): (*|number)}
 */
const sortFn = (sortColumns) => {
    return function sortFnWithColumns(a, b) {
        for( let column of sortColumns ) {
            const a1 = a[column.index]
            const b1 = b[column.index]
            if(a1 !== b1)
                return ( a1 > b1 ? 1 : -1 ) * ( column.direction === 'asc' ? 1 : -1)
        }
        return 0;
    }
}

export {sortFn}